export default __webpack_public_path__ + "static/media/aveda-logo.8888ba16.svg";